import { Record } from '@common/data-models/records/record';
import { PSTFieldNames } from '@suite/common/data-models/fields/pst-field-names';
import { ObjectTypes } from '@suite/common/enums/object-types';
import { FieldDef } from "@common/data-models/service/field-def";
import { Relationship } from '@common/data-models/complex-types/relationship';
import { DataStore } from "@common/data-models/data-store/data-store";

export class PublicationRecord extends Record {

    //AT: we could also create a LinkedRecord , place the linkedRecord logic there. then Pub record can extend LinkedRecord, etc. 
    private _linkedRecord: Record = null;

    constructor() {
        super();
        this.type = ObjectTypes.PUBLICATION;
    }

    public get publicationApproved(): boolean { return this.getAs<boolean>(PSTFieldNames.PSTPublicationApproved); }
    public set publicationApproved(value: boolean) { this.set(PSTFieldNames.PSTPublicationApproved, value); }

    public get parentGuid(): string {
        let parentGuid = this.getAs<string>("ParentGuid");
        if (!parentGuid) {
            // Extract parent guid from the path
            if (this.path) {
                parentGuid = this.path.parentCollectionGuid;
            }
        }
        return parentGuid;
    }
    public set parentGuid(value: string) { this.set("ParentGuid", value); }

    private static _fieldDefsDict: { [id: string]: FieldDef } = null;
    public get fieldDefsDict(): { [id: string]: FieldDef } {
        if (!PublicationRecord._fieldDefsDict) {
            PublicationRecord._fieldDefsDict = {};
            for (let key in Record.globalTablesService.FieldDefsDict) {
                if (Record.globalTablesService.FieldDefsDict[key].PublicationProp) {
                    PublicationRecord._fieldDefsDict[key] = Record.globalTablesService.FieldDefsDict[key];
                }
            }
        }
        return PublicationRecord._fieldDefsDict;
    }

    public get linkedRecord(): Record {
        if (!this._linkedRecord && this.relationships && this.relationships.getRowCount() > 0) {
            // try to fetch from DataStore, if it exists there. We always have one link for each pub record
            // so we always take the guid at row 0
            this._linkedRecord = DataStore.byGuid<Record>(this.relationships.getGuid(0), "");
        }
        return this._linkedRecord;
    }

    public set linkedRecord(rec: Record) {
        this._linkedRecord = rec;
    }

}
